import { render, staticRenderFns } from "./ModalImportStorePrices.vue?vue&type=template&id=351e8ad0&scoped=true&lang=pug"
import script from "./ModalImportStorePrices.vue?vue&type=script&lang=js"
export * from "./ModalImportStorePrices.vue?vue&type=script&lang=js"
import style0 from "./ModalImportStorePrices.vue?vue&type=style&index=0&id=351e8ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e8ad0",
  null
  
)

export default component.exports